import { GetCompanyBalancePerPeriodType } from "../homeAPI";
import { GetTransactionsAmountsPerPeriodType } from "../transactions/transactionsAPI";

export const fakeTransactionsAmountsPerPeriodForDemo: GetTransactionsAmountsPerPeriodType =
  {
    year: {
      categoriesAmounts: [
        {
          category: "WASH",
          amount: 44940,
        },
        {
          category: "FUEL_AUTOMATON",
          amount: 607100,
        },
        {
          category: "MAINTENANCE",
          amount: 48600,
        },
        {
          category: "PARKING",
          amount: 47170,
        },
        {
          category: "TOLL",
          amount: 74990,
        },
      ],
      averagePricePerLiter: [
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 1.51,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 1.32,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 1.49,
        },
        {
          date: "2025-04-01T00:00:00.000Z",
          value: 1.6,
        },
        {
          date: "2025-05-01T00:00:00.000Z",
          value: 1.72,
        },
        {
          date: "2025-06-01T00:00:00.000Z",
          value: 1.61,
        },
        {
          date: "2025-07-01T00:00:00.000Z",
          value: 1.51,
        },
        {
          date: "2025-08-01T00:00:00.000Z",
          value: 1.32,
        },
        {
          date: "2025-09-01T00:00:00.000Z",
          value: 1.49,
        },
        {
          date: "2025-10-01T00:00:00.000Z",
          value: 1.6,
        },
        {
          date: "2025-11-01T00:00:00.000Z",
          value: 1.72,
        },
        {
          date: "2025-12-01T00:00:00.000Z",
          value: 1.61,
        },
      ],
      totalCarbonEmission: [
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 110,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 121,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 133,
        },
        {
          date: "2025-04-01T00:00:00.000Z",
          value: 112,
        },
        {
          date: "2025-05-01T00:00:00.000Z",
          value: 125,
        },
        {
          date: "2025-06-01T00:00:00.000Z",
          value: 130,
        },
        {
          date: "2025-07-01T00:00:00.000Z",
          value: 100,
        },
        {
          date: "2025-08-01T00:00:00.000Z",
          value: 101,
        },
        {
          date: "2025-09-01T00:00:00.000Z",
          value: 102,
        },
        {
          date: "2025-10-01T00:00:00.000Z",
          value: 112,
        },
        {
          date: "2025-11-01T00:00:00.000Z",
          value: 125,
        },
        {
          date: "2025-12-01T00:00:00.000Z",
          value: 130,
        },
      ],
      merchantGroupsAmounts: [
        {
          merchantGroup: null,
          amount: 13404,
        },
        {
          merchantGroup: "BP",
          amount: 4800,
        },
        {
          merchantGroup: "TOTAL_ENERGIES",
          amount: 3306,
        },
        {
          merchantGroup: "INTERMARCHE",
          amount: 60770,
        },
      ],
      averagePricePerLiterPerFuel: [
        {
          fuel: "SP95",
          data: [
            {
              date: "2025-01-01T00:00:00.000Z",
              value: 1.51,
            },
            {
              date: "2025-02-01T00:00:00.000Z",
              value: 1.32,
            },
            {
              date: "2025-03-01T00:00:00.000Z",
              value: 1.49,
            },
            {
              date: "2025-04-01T00:00:00.000Z",
              value: 1.6,
            },
            {
              date: "2025-05-01T00:00:00.000Z",
              value: 1.72,
            },
            {
              date: "2025-06-01T00:00:00.000Z",
              value: 1.61,
            },
            {
              date: "2025-07-01T00:00:00.000Z",
              value: 1.51,
            },
            {
              date: "2025-08-01T00:00:00.000Z",
              value: 1.32,
            },
            {
              date: "2025-09-01T00:00:00.000Z",
              value: 1.49,
            },
            {
              date: "2025-10-01T00:00:00.000Z",
              value: 1.6,
            },
            {
              date: "2025-11-01T00:00:00.000Z",
              value: 1.72,
            },
            {
              date: "2025-12-01T00:00:00.000Z",
              value: 1.61,
            },
          ],
        },
        {
          fuel: "Adblue",
          data: [
            {
              date: "2025-01-01T00:00:00.000Z",
              value: 0.69,
            },
            {
              date: "2025-02-01T00:00:00.000Z",
              value: 0.71,
            },
            {
              date: "2025-03-01T00:00:00.000Z",
              value: 0.55,
            },
            {
              date: "2025-04-01T00:00:00.000Z",
              value: 0.6,
            },
            {
              date: "2025-05-01T00:00:00.000Z",
              value: 0.72,
            },
            {
              date: "2025-06-01T00:00:00.000Z",
              value: 0.69,
            },
            {
              date: "2025-07-01T00:00:00.000Z",
              value: 0.69,
            },
            {
              date: "2025-08-01T00:00:00.000Z",
              value: 0.62,
            },
            {
              date: "2025-09-01T00:00:00.000Z",
              value: 0.61,
            },
            {
              date: "2025-10-01T00:00:00.000Z",
              value: 0.6,
            },
            {
              date: "2025-11-01T00:00:00.000Z",
              value: 0.72,
            },
            {
              date: "2025-12-01T00:00:00.000Z",
              value: 0.69,
            },
          ],
        },
      ],
    },
    month: {
      categoriesAmounts: [
        {
          category: "WASH",
          amount: 3000,
        },
        {
          category: "FUEL_AUTOMATON",
          amount: 40591,
        },
        {
          category: "MAINTENANCE",
          amount: 3050,
        },
        {
          category: "PARKING",
          amount: 4000,
        },
        {
          category: "TOLL",
          amount: 6249,
        },
      ],
      averagePricePerLiter: [
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 1.51,
        },
        {
          date: "2025-01-02T00:00:00.000Z",
          value: 1.42,
        },
        {
          date: "2025-01-03T00:00:00.000Z",
          value: 1.49,
        },
        {
          date: "2025-01-05T00:00:00.000Z",
          value: 1.61,
        },
        {
          date: "2025-01-07T00:00:00.000Z",
          value: 1.53,
        },
        {
          date: "2025-01-10T00:00:00.000Z",
          value: 1.43,
        },
        {
          date: "2025-01-17T00:00:00.000Z",
          value: 1.55,
        },
        {
          date: "2025-01-18T00:00:00.000Z",
          value: 1.5,
        },
        {
          date: "2025-01-19T00:00:00.000Z",
          value: 1.49,
        },
        {
          date: "2025-01-21T00:00:00.000Z",
          value: 1.45,
        },
        {
          date: "2025-01-25T00:00:00.000Z",
          value: 1.54,
        },
        {
          date: "2025-01-27T00:00:00.000Z",
          value: 1.61,
        },
      ],
      totalCarbonEmission: [
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 121,
        },
        {
          date: "2025-01-02T00:00:00.000Z",
          value: 121,
        },
        {
          date: "2025-01-03T00:00:00.000Z",
          value: 123,
        },
        {
          date: "2025-01-04T00:00:00.000Z",
          value: 112,
        },
        {
          date: "2025-01-08T00:00:00.000Z",
          value: 115,
        },
        {
          date: "2025-01-11T00:00:00.000Z",
          value: 130,
        },
        {
          date: "2025-01-14T00:00:00.000Z",
          value: 111,
        },
        {
          date: "2025-01-15T00:00:00.000Z",
          value: 121,
        },
        {
          date: "2025-01-17T00:00:00.000Z",
          value: 102,
        },
        {
          date: "2025-01-22T00:00:00.000Z",
          value: 114,
        },
        {
          date: "2025-01-25T00:00:00.000Z",
          value: 123,
        },
        {
          date: "2025-01-28T00:00:00.000Z",
          value: 130,
        },
      ],
      merchantGroupsAmounts: [
        {
          merchantGroup: null,
          amount: 4100,
        },
        {
          merchantGroup: "BP",
          amount: 4800,
        },
        {
          merchantGroup: "TOTAL_ENERGIES",
          amount: 3306,
        },
        {
          merchantGroup: "INTERMARCHE",
          amount: 51000,
        },
      ],
      averagePricePerLiterPerFuel: [
        {
          fuel: "SP95",
          data: [
            {
              date: "2025-01-01T00:00:00.000Z",
              value: 1.51,
            },
            {
              date: "2025-01-03T00:00:00.000Z",
              value: 1.72,
            },
            {
              date: "2025-01-06T00:00:00.000Z",
              value: 1.49,
            },
            {
              date: "2025-01-11T00:00:00.000Z",
              value: 1.51,
            },
            {
              date: "2025-01-22T00:00:00.000Z",
              value: 1.72,
            },
            {
              date: "2025-01-28T00:00:00.000Z",
              value: 1.49,
            },
          ],
        },
        {
          fuel: "Adblue",
          data: [
            {
              date: "2025-01-01T00:00:00.000Z",
              value: 0.69,
            },
            {
              date: "2025-01-03T00:00:00.000Z",
              value: 0.72,
            },
            {
              date: "2025-01-06T00:00:00.000Z",
              value: 0.61,
            },
            {
              date: "2025-01-11T00:00:00.000Z",
              value: 0.69,
            },
            {
              date: "2025-01-22T00:00:00.000Z",
              value: 0.72,
            },
            {
              date: "2025-01-28T00:00:00.000Z",
              value: 0.61,
            },
          ],
        },
      ],
    },
    quarter: {
      categoriesAmounts: [
        {
          category: "WASH",
          amount: 11235,
        },
        {
          category: "FUEL_AUTOMATON",
          amount: 100775,
        },
        {
          category: "MAINTENANCE",
          amount: 12150,
        },
        {
          category: "PARKING",
          amount: 11792,
        },
        {
          category: "TOLL",
          amount: 22222,
        },
      ],
      averagePricePerLiter: [
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 1.51,
        },
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 1.52,
        },
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 1.49,
        },
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 1.61,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 1.53,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 1.53,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 1.55,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 1.5,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 1.49,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 1.55,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 1.54,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 1.61,
        },
      ],
      totalCarbonEmission: [
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 110,
        },
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 111,
        },
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 123,
        },
        {
          date: "2025-01-01T00:00:00.000Z",
          value: 112,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 125,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 118,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 100,
        },
        {
          date: "2025-02-01T00:00:00.000Z",
          value: 101,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 109,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 112,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 125,
        },
        {
          date: "2025-03-01T00:00:00.000Z",
          value: 130,
        },
      ],
      merchantGroupsAmounts: [
        {
          merchantGroup: null,
          amount: 3404,
        },
        {
          merchantGroup: "BP",
          amount: 4800,
        },
        {
          merchantGroup: "TOTAL_ENERGIES",
          amount: 3306,
        },
        {
          merchantGroup: "INTERMARCHE",
          amount: 60770,
        },
      ],
      averagePricePerLiterPerFuel: [
        {
          fuel: "SP95",
          data: [
            {
              date: "2025-01-01T00:00:00.000Z",
              value: 1.51,
            },
            {
              date: "2025-02-01T00:00:00.000Z",
              value: 1.72,
            },
            {
              date: "2025-03-01T00:00:00.000Z",
              value: 1.49,
            },
          ],
        },
        {
          fuel: "Adblue",
          data: [
            {
              date: "2025-01-01T00:00:00.000Z",
              value: 0.69,
            },
            {
              date: "2025-02-01T00:00:00.000Z",
              value: 0.72,
            },
            {
              date: "2025-03-01T00:00:00.000Z",
              value: 0.61,
            },
          ],
        },
      ],
    },
  };

export const fakeBalancePerPeriodForDemo: GetCompanyBalancePerPeriodType = {
  year: [
    {
      day: "2025-01-01T00:00:00.000Z",
      amount: 200000,
    },
    {
      day: "2025-02-01T00:00:00.000Z",
      amount: 120000,
    },
    {
      day: "2025-03-01T00:00:00.000Z",
      amount: 60000,
    },
    {
      day: "2025-03-01T12:00:00.000Z",
      amount: 220000,
    },
    {
      day: "2025-04-01T00:00:00.000Z",
      amount: 200000,
    },
    {
      day: "2025-05-01T00:00:00.000Z",
      amount: 145000,
    },
    {
      day: "2025-06-01T00:00:00.000Z",
      amount: 80000,
    },
    {
      day: "2025-07-01T00:00:00.000Z",
      amount: 30000,
    },
    {
      day: "2025-07-01T12:00:00.000Z",
      amount: 220000,
    },
    {
      day: "2025-08-01T00:00:00.000Z",
      amount: 190000,
    },
    {
      day: "2025-09-01T00:00:00.000Z",
      amount: 120000,
    },
    {
      day: "2025-10-01T00:00:00.000Z",
      amount: 40000,
    },
    {
      day: "2025-11-01T00:00:00.000Z",
      amount: 10000,
    },
    {
      day: "2025-12-01T00:00:00.000Z",
      amount: 220000,
    },
  ],
  month: [
    {
      day: "2025-01-01T00:00:00.000Z",
      amount: 200000,
    },
    {
      day: "2025-01-03T00:00:00.000Z",
      amount: 190800,
    },
    {
      day: "2025-01-05T00:00:00.000Z",
      amount: 190000,
    },
    {
      day: "2025-01-07T00:00:00.000Z",
      amount: 180000,
    },
    {
      day: "2025-01-08T00:00:00.000Z",
      amount: 163000,
    },
    {
      day: "2025-01-12T00:00:00.000Z",
      amount: 160000,
    },
    {
      day: "2025-01-13T00:00:00.000Z",
      amount: 157000,
    },
    {
      day: "2025-01-16T00:00:00.000Z",
      amount: 150000,
    },
    {
      day: "2025-01-20T00:00:00.000Z",
      amount: 140000,
    },
    {
      day: "2025-01-23T00:00:00.000Z",
      amount: 130000,
    },
    {
      day: "2025-01-28T00:00:00.000Z",
      amount: 123000,
    },
    {
      day: "2025-01-30T00:00:00.000Z",
      amount: 120000,
    },
  ],
  quarter: [
    {
      day: "2025-01-01T00:00:00.000Z",
      amount: 200000,
    },
    {
      day: "2025-01-10T00:00:00.000Z",
      amount: 190800,
    },
    {
      day: "2025-01-20T00:00:00.000Z",
      amount: 160000,
    },
    {
      day: "2025-01-30T00:00:00.000Z",
      amount: 140000,
    },
    {
      day: "2025-02-01T00:00:00.000Z",
      amount: 120000,
    },
    {
      day: "2025-02-10T00:00:00.000Z",
      amount: 110000,
    },
    {
      day: "2025-02-20T00:00:00.000Z",
      amount: 90000,
    },
    {
      day: "2025-02-30T00:00:00.000Z",
      amount: 75000,
    },
    {
      day: "2025-03-01T00:00:00.000Z",
      amount: 60000,
    },
    {
      day: "2025-03-01T12:00:00.000Z",
      amount: 220000,
    },
    {
      day: "2025-03-10T00:00:00.000Z",
      amount: 210000,
    },
    {
      day: "2025-03-20T00:00:00.000Z",
      amount: 205000,
    },
    {
      day: "2025-03-30T00:00:00.000Z",
      amount: 190590,
    },
  ],
};
